module.exports = __webpack_public_path__ + "static/media/Activity.e64ec243.svg";